"use client";

import { twMerge } from "tailwind-merge";
import { setupCoinArc } from "./three/coinArc";
import { useThreeCanvas } from "./three/useThreeCanvas";

/**
 * Silver coins running along an arc in the final CTA section (Figma "moedas-arco-render").
 * Positions itself inside the parent `relative overflow-hidden` section; the static Figma render
 * shows until the first WebGL frame, and stays if WebGL is unavailable.
 */
export default function EliteCoinArc({ className }: { className?: string }) {
  const { containerRef, ready } = useThreeCanvas(setupCoinArc, { maxDpr: 1.5 });

  return (
    <div
      ref={containerRef}
      aria-hidden="true"
      className={twMerge(
        // Mobile: Figma's 808.9×197px box scaled 1.2× around its centre (coins read too small at 1×)
        "absolute left-[-31.667rem] top-[67.161rem] h-[29.544rem] w-[121.334rem]",
        // Above 1920px the root font-size follows a 2200px design width, so rem alone would leave the
        // arc short of the screen edges: never narrower than 102.03vw (= 244.877rem at 1920), same aspect.
        "lg:left-[calc(50%+0.099rem)] lg:top-[62.25rem] lg:h-[max(59.625rem,24.846vw)] lg:w-[max(244.877rem,102.03vw)] lg:-translate-x-1/2",
        className,
      )}
    >
      {!ready && (
        <picture>
          <source media="(min-width: 993px)" srcSet="/elite/coins-arc-desktop.png" />
          <img
            src="/elite/coins-arc-mobile.png"
            alt=""
            loading="lazy"
            decoding="async"
            className="pointer-events-none absolute inset-0 h-full w-full select-none object-contain"
          />
        </picture>
      )}
    </div>
  );
}
